import {SET_POINTS_BANNER} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  
  selectedData: null,
  formType: "",
  formId: "",
  formTitle: "",

  image: null,
  browser: null,
  url: "",
  sort: 0,
  isEasyPromos: false,
  promoId: "",
  visibilityType: {
    label: 'Always On',
    value: 'AO'
  },
  visibilityStartTime: '',
  visibilityEndTime: '',
  campaignStartDate: '',
  campaignEndDate: "",

  cardType: [],
  specificUser: [],
  blacklistedUser: [],
  deviceType: {
    label: 'All',
    value: 'ALL'  
  },
  isUploadingCSVFile: false,
  isUploadingCSVFileBlacklistedUser: false,

  browserOptions: [
    {
        label: "INTERNAL",
        value: "INTERNAL"
    },
    {
        label: "EXTERNAL",
        value: "EXTERNAL"
    }
  ],
  visibilityOptions: [
    {
      label: 'Always On',
      value: 'AO'
    },
    {
      label: 'Time Range',
      value: 'TR'
    }
  ],
  deviceTypeOptions: [
    {
      label: 'ALL',
      value: 'ALL'  
    },
    {
      label: 'ANDROID',
      value: 'ANDROID'  
    },
    {
      label: 'IOS',
      value: 'IOS'  
    },
  ],

  showModalConfig: false,
  isSavingConfig: false,
  isLoadingConfig: false,
  isActive: false,
  lifestyleBannerConfig: null,

  delayConfig_showModal: false,
  delayConfig_isSaving: false,
  delayConfig_isLoading: false,
  delayConfig: null,
  delayConfig_value: ""
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case SET_POINTS_BANNER:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/PointsBanner.js